import { Controller } from "@hotwired/stimulus"

// 모달 컨트롤러
// 모달 창의 열기/닫기 기능을 제공합니다.
export default class extends Controller {
  static values = {
    active: { type: Boolean, default: false }
  }
  
  static classes = ["active"]

  connect() {
    // ESC 키 이벤트 리스너 추가
    this.escapeHandler = this.escapeHandler.bind(this)
    document.addEventListener("keydown", this.escapeHandler)
    
    // 초기 상태 설정
    if (this.activeValue) {
      this.open()
    } else {
      this.close()
    }
  }

  disconnect() {
    // ESC 키 이벤트 리스너 제거
    document.removeEventListener("keydown", this.escapeHandler)
  }

  open() {
    // 모달 열기
    this.element.classList.add(...this.activeClasses)
    this.element.classList.remove("hidden")
    
    // 스크롤 방지
    document.body.style.overflow = "hidden"
    
    this.activeValue = true
  }

  close() {
    // 모달 닫기
    this.element.classList.remove(...this.activeClasses)
    this.element.classList.add("hidden")
    
    // 스크롤 복원
    document.body.style.overflow = ""
    
    this.activeValue = false
  }

  escapeHandler(event) {
    // ESC 키로 모달 닫기
    if (event.key === "Escape" && this.activeValue) {
      this.close()
    }
  }
}
